'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationInputContainer = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _Sagas = require('decorators/Sagas');

var _decorator = require('helpers/decorator');

var _verify = require('helpers/verify');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

var _LocationInput = require('./LocationInput.reducer');

var _LocationInput2 = require('./LocationInput.saga');

var _LocationInput3 = require('./LocationInput');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var detectedLocation = (0, _locale.selectUserDetectedLocation)(state);
  var inputQuery = (0, _LocationInput.selectPlaceQuery)(state);
  var predictionData = _bound.searchLocationAutocomplete.data(state, 'locationInput_' + inputQuery) || {};

  return {
    hasDetectedLocation: !(0, _verify.isEmpty)(detectedLocation),
    inputLocation: (0, _LocationInput.selectInputLocation)(state),
    placeSuggestions: predictionData.predictions || [],
    selectedItem: (0, _LocationInput.selectInputSelection)(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  queryPlaces: _LocationInput2.queryPlaces,
  loadPlace: _LocationInput2.loadPlace,
  loadDetectedLocation: _LocationInput2.loadDetectedLocation,
  setInputSelection: _LocationInput.setInputSelection
};

var LocationInputContainer = exports.LocationInputContainer = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _Sagas.withSagas)({ watch: _LocationInput2.watchLocationInputSagas }))(_LocationInput3.LocationInput);